function wu_data_ratio() {
    $('img[data-ratio]').each(function() {
        var ratio = $(this).attr('data-ratio');
        $(this).wrap('<div class="ratio__image" style="padding-bottom:' + ratio + '%"></div>');
    });
}
wu_data_ratio();


function wu_data_height() {
    var height = $('.module__images').outerHeight();
    $('.module__image').each(function(index, el) {
        var ratio = $(this).attr('data-height');
        $(this).width(height * ratio).height(height);
    });
}

$(window).resize(function() {
    wu_data_height();
});


jQuery(document).ready(function($) {
    wu_data_height();
    if ($('.module__arrows').length > 0) {
        $('.module__images').slick({
            appendArrows: $('.module__arrows'),
            prevArrow: '<a href="#" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
            nextArrow: '<a href="#" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
            speed: 800,
            centerMode: true,
            slidesToShow: 1,
            variableWidth: true

        });

    } else {
        $('.module__images').slick({
            centerMode: true,
            slidesToShow: 3,
        });
    }
});
